import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import {BookProvider} from './context';
import * as serviceWorker from './serviceWorker';
// BookProvider is the top component in this application
ReactDOM.render(
  <BookProvider>
    <Router>
      <App />
    </Router>
  </BookProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
